import { Component, OnInit, Input, OnDestroy, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PopoverController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { PostCommentsPage } from 'src/app/modals/post-comments/post-comments.page';
import { ToolsService } from 'src/app/services/tools.service';
import { ConfigService } from 'src/app/services/config.service';
import { PopoverComponent } from '../popover/popover.component';


@Component({
  selector: 'app-social-card',
  templateUrl: './social-card.component.html',
  styleUrls: ['./social-card.component.scss'],
})
export class SocialCardComponent implements OnInit, OnDestroy {

  @Input() post;
  private commentSubscription: Subscription;

  formControl = new FormControl('', [Validators.required])

  slideOptions = {
    initialSlide: 0,
    spaceBetween: 0,
    slidesPerView: 'auto',
  };

  constructor(
    private domSanitizer: DomSanitizer,
    public authService: AuthService,
    public modalController: ModalController,
    public toolsService: ToolsService,
    public configService: ConfigService,
    private popoverController: PopoverController
  ) {
  }

  private buildYoutubeEmbedUrl(youtubeId: string): string {
    return `https://www.youtube-nocookie.com/embed/${youtubeId}`;
  }

  private sanitizeYoutubeEmbedUrl(youtubeId: string) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.buildYoutubeEmbedUrl(youtubeId));
  }

  ngOnInit() {
    // if (this.post.text) this.post.text = this.domSanitizer.bypassSecurityTrustHtml(this.post.text);
    if (this.post.text) this.post.text = this.domSanitizer.sanitize(SecurityContext.HTML, this.post.text);
    if (Array.isArray(this.post.videos)) {
      this.post.videos = this.post.videos
        .filter(v => !!v.youtube_id)
        .map(v => ({
          ...v,
          safeEmbedUrl: this.sanitizeYoutubeEmbedUrl(v.youtube_id)
        }));
    } else {
      this.post.videos = [];
    }

    this.post.comments = []
    if (this.post.last_comment) {
      this.post.comments.push(this.post.last_comment)
    }
    this.commentSubscription = this.configService.commentCreated$.subscribe(() => {
      this.post.count_comments += 1;
    });
  }

  ngOnDestroy() {
    this.commentSubscription.unsubscribe();
  }

  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: ev,
      translucent: true,
      componentProps: {
        post: this.post
      }
    });
    return await popover.present();
  }

  async createComment() {
    if (this.formControl.valid) {
      await this.toolsService.showLoader();
      try {
        let result = await this.configService.createComment(this.formControl.value, this.authService.player_initial_data.id, this.post.id)
        this.post.count_comments++
        console.log("result", result)
        this.formControl.setValue("")
        this.post.comments.unshift(result)
      } catch (error) {
        console.error(error)
      }
      this.toolsService.dismissLoader();
    }

  }


  async presentModal() {
    const modal = await this.modalController.create({
      component: PostCommentsPage,
      cssClass: 'how-to-redeem2',
      componentProps: {
        post_id: this.post.id,
        onEditCallback: this.onEditComment,
        onDeleteCallback: this.onDeleteComment
      }
    });
    modal.onDidDismiss()
      .then((response) => {
        console.log(response)
        if (response.data) {
          console.log('to redeem reward')
        }
      });
    return await modal.present();
  }

  onEditComment = (commentId, commentText) => {
    this.post.comments.forEach(comment => {
      if (comment.id == commentId) {
        comment.text = commentText
      }
    });
  }

  onDeleteComment = (commentId, commentsCount) => {
    this.post.comments = this.post.comments.filter(comment => comment.id != commentId)
    this.post.count_comments = commentsCount;
  }

}
